import React from "react";
import Navbar from "../components/Navbar";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMapMarker,
  FaPhoneAlt,
  FaYoutube,
} from "react-icons/fa";
import BottomNavbar from "../components/BottomNavbar";
import { FaX } from "react-icons/fa6";

function Contact() {
  return (
    <>
      <Navbar current="contact" />
      <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 items-center bg-gray-100 px-4 sm:px-6 md:px-20 py-20">
        <div className="w-full max-w-lg bg-white p-6 sm:p-8 rounded-lg shadow-lg mt-6 text-center">
          <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>

          {/* Grid Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            {/* Email Box */}
            <div className="border border-gray-100 rounded-lg p-4 shadow-sm flex flex-col items-center bg-gray-200 text-center">
              <FaEnvelope size={24} className="text-primary mb-2" />
              <h4 className="font-semibold">Email</h4>

              <p className="text-gray-700">
                {" "}
                <a href="mailto:info@rehobothstandardcables.com">
                  info@rehobothstandardcables.com
                </a>{" "}
              </p>
              <p className="text-gray-700 ">
                {" "}
                <a href="mailto:rehoboth_wireandcable@yahoo.co.uk">
                  rehoboth_wireandcable@yahoo.co.uk
                </a>{" "}
              </p>
            </div>

            {/* Phone Box */}
            <div className="border border-gray-100 rounded-lg p-4 shadow-sm flex flex-col items-center bg-gray-200 text-center">
              <FaPhoneAlt size={24} className="text-primary mb-2" />
              <h4 className="font-semibold">Phone</h4>
              <p className="text-gray-700">
                <a href="tel:+2348033607144">+2348033607144</a>
              </p>
            </div>

            {/* Address Box 1 */}
            <div className="border border-gray-100 rounded-lg p-4 shadow-sm flex flex-col items-center bg-gray-200 text-center">
              <FaMapMarker size={24} className="text-primary mb-2" />
              <h4 className="font-semibold">Kaduna Address</h4>
              <a
                href="https://maps.app.goo.gl/oAXg6xe25W7Ui1qz5"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:underline cursor-pointer"
              >
                <p className="text-gray-700">
                  1st floor dabino house, Yakubu Gowon way, Kaduna, Nigeria
                </p>
              </a>
            </div>

            {/* Address Box 2 */}
            <div className="border border-gray-100 rounded-lg p-4 shadow-sm flex flex-col items-center bg-gray-200 text-center">
              <FaMapMarker size={24} className="text-primary mb-2" />
              <h4 className="font-semibold">Lagos Address</h4>
              <a
                href="https://maps.app.goo.gl/EyYoRLvbvRn5LQw27?g_st=aw"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:underline cursor-pointer"
              >
                <p className="text-gray-700">
                  Plot 9 Ladipo Oluwole off Adeniyi Jones, Ikeja. Lagos,
                  Nigeria.
                </p>
              </a>
            </div>

            <div className="border border-gray-100 rounded-lg p-4 shadow-sm flex flex-col items-center bg-gray-200 text-center">
              <h2 className="font-semibold">Get Social</h2>
              <div className="flex space-x-4 text-lg text-primary mt-5">
                <a href="https://www.instagram.com/rehobothsil">
                  <FaInstagram />
                </a>
                <a href="https://www.facebook.com/share/1H6BhR141Y/">
                  <FaFacebook />
                </a>
                <a href="https://www.linkedin.com/company/rehoboth-sil/">
                  <FaLinkedin />
                </a>
                <a href="https://x.com/RehobothSIL?t=UDe5rRQt_nT0owXdzH6f2A&s=09">
                  <FaX />
                </a>
                <a href="https://www.youtube.com/@rehoboth-sil">
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-lg mt-10">
          <h2 className="text-3xl font-bold mb-4 text-center text-primary">
            Contact Us
          </h2>
          <p className="text-gray-600 text-center mb-6">
            We'd love to hear from you! Fill out the form below and we'll get
            back to you as soon as we can.
          </p>
          <form className="space-y-4">
            <div>
              <label className="block text-gray-700">Your Name</label>
              <input
                type="text"
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="John Doe"
              />
            </div>
            <div>
              <label className="block text-gray-700">Your Email</label>
              <input
                type="email"
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="youremail@example.com"
              />
            </div>
            <div>
              <label className="block text-gray-700">Your Message</label>
              <textarea
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Type your message here..."
                rows={5}
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full py-2 px-4 text-white rounded-md bg-primary hover:bg-primary-dark"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
      <BottomNavbar current="contact" />
    </>
  );
}

export default Contact;
